<template>
  <div v-if="label">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a @click="goTo('/')" class="navbar-item">
            <img src="../assets/dgologos.png">
          </a>

          <a
            role="button"
            class="navbar-burger burger has-text-centered"
            :class="{'is-active': menuExpanded}"
            @click="menuExpanded = !menuExpanded"
            aria-label="menu"
            :aria-expanded="menuExpanded ? 'true' : 'false'"
            data-target="navbar-burger"
            data-testid="mobile-menu-button">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div
          id="navbar-burger"
          class="navbar-menu"
          :class="{'is-active': menuExpanded}">

          <div class="navbar-start">
            <a @click="goTo('/')" class="navbar-item" :class="{'router-link-exact-active': this.$route.path == '/'}">{{label.titles.home}}</a>
            <a @click="goTo('/data')" class="navbar-item" :class="{'router-link-exact-active': this.$route.path == '/data'}">{{label.titles.data}}</a>
            <!-- <a @click="goTo('/comparison')" class="navbar-item" :class="{'router-link-exact-active': this.$route.path == '/comparison'}">{{label.titles.comparison}}</a> -->
            <a @click="$route.path.startsWith('/profile') ? null : goTo('/profile')" class="navbar-item" :class="{'router-link-exact-active': this.$route.path.startsWith('/profile')}">{{label.titles.profile}}</a>
            <a v-if="showAdminHeader" @click="goTo('/admin/hpRequests')" class="navbar-item" :class="{'router-link-exact-active': this.$route.path.startsWith('/admin')}">{{label.titles.admin}}</a>
          </div>

          <div class="navbar-end">
            <div class="buttons">
              <!-- language selection -->
              <!-- <div class="dropdown" :class="{'is-active': languageActive}">
                <div class="dropdown-trigger">
                  <button class="button" @click="languageActive = !languageActive" @blur="languageActive = false">
                    <span>{{locale}}</span>
                    <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                  </button>
                </div>
                <div class="dropdown-menu " role="menu">
                  <div class="dropdown-content">
                    <a class="dropdown-item" @mousedown="switchLocale('fr')">{{label.buttons.french}}</a>
                    <a class="dropdown-item" @mousedown="switchLocale('nl')">{{label.buttons.dutch}}</a>
                    <a class="dropdown-item" @mousedown="switchLocale('de')">{{label.buttons.german}}</a>
                  </div>
                </div>
              </div> -->

              <!-- custom user login version -->
              <!-- <div v-if="!account.user.token" class="navbar-item navbar-flex">
                  <a @click="goTo('/register')" class="button is-light">
                    <awesome-icon class="button-icon" icon="user-plus"/>{{label.buttons.register}}
                  </a>
                  <a @click="goTo('/login')" class="button is-primary">
                    <strong>
                      <awesome-icon class="button-icon" icon="sign-in-alt"/>{{label.buttons.login}}
                    </strong>
                  </a>
              </div>

              <div v-else class="navbar-item navbar-flex">
                <a class="bell-icon" :class="{'hasNotif': notifNumber > 0}" @click="showNotifModal = true">
                  <awesome-icon icon="bell" size="lg"/>
                  <span v-if="notifNumber > 0" class="bell-notif">{{notifNumber}}</span>
                </a>
                <a class="button is-light">
                  {{account.user.email}}
                </a>
                <a class="button is-primary" @click="menuExpanded = !menuExpanded; logout();">
                  <awesome-icon class="button-icon" icon="sign-out-alt"/>{{label.buttons.logout}}
                </a>
              </div> -->
              
              <div style="margin-right: 2px;">
                <a 
                  class="button"
                  style="padding-left: 6px;padding-right: 4px;"
                  href="/doc_users/index.html"
                  target="_blank">
                  <span style="margin-right: 4px;">Manuel d'utilisation</span>
                  <awesome-icon class="button-icon" icon="book-open"/>
                </a>
              </div>

              <!-- notifications -->
              <div v-if="$auth && $auth.isAuthenticated" class="navbar-item navbar-flex">
                <!-- <a class="bell-icon" :class="{'hasNotif': notifNumber > 0}" @click="showNotifModal = true">
                  <awesome-icon icon="bell" size="lg"/>
                  <span v-if="notifNumber > 0" class="bell-notif">{{notifNumber}}</span>
                </a> -->
                <a style="max-width: 200px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: inline-block;"
                class="button is-light"
                :title="account.user.email">
                  {{account.user.email}}
                </a>
                <!-- <a class="button is-primary" @click="menuExpanded = !menuExpanded; logout();">
                  <awesome-icon class="button-icon" icon="sign-out-alt"/>{{label.buttons.logout}}
                </a> -->
              </div>

              <!-- auth0 login version -->
              <Auth0Button :account="account"></Auth0Button>

              <!-- Modal Notification -->
              <div class="modal" :class="{ 'is-active': showNotifModal }">
                <div class="modal-background" @click="showNotifModal = false"></div>
                <div class="modal-content">
                  <div class="box">
                    <div class="horizontal-wrapper">
                      <h2 class="subtitle">{{label.titles.notification}}</h2>
                      <button class="delete" @click="showNotifModal = false"></button>
                    </div>

                    <div class="notif-parent">
                      <div class="notif" v-for="alertLog in alertLogs" :key="alertLog.id">
                        <div class="notif-content">
                          <p><strong>{{alertLog.date}}</strong> - {{alertLog.source}}</p>
                          <p>{{alertLog.message}}</p>
                        </div>
                        <div class="notif-seen">
                          <div v-if="!alertLog.seen" class="notif-seen-button has-tooltip-left" data-tooltip="Marquer comme lu" @click="markAsSeen(alertLog.id)"></div>
                        </div>
                      </div>
                    </div>

                    <div class="see-more" v-if="!lastPage">
                      <a class="button is-white" @click="loadNextNotifications">{{label.buttons.seeMore}} ...</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { AlertLogsService } from '../services';
import moment from 'moment';
import Auth0Button from "./auth0Button.vue";
import { getInstance } from '../auth';

export default {
  components: {
    Auth0Button
  },
  data() {
    return {
      menuExpanded: false,
      languageActive: false,
      alertLogs: [],
      showNotifModal: false,
      lastPage: false,
      pageNumber: 0,
      notificationsPerPage: 3
    }
  },
  computed: {
    ...mapState({ label: state => state.labels.header }),
    ...mapState({ locale: state => state.labels.locale }),
    ...mapState("account", ["user"]),
    ...mapState({ account: state => state.account }),
    notifNumber() {
      return this.alertLogs.filter(alertLog => alertLog.seen === false).length
    },
    showAdminHeader() {
      const auth = getInstance();
      return auth.isAuthenticated && this.account.user && this.account.user.admin;
    }
  },
  methods: {
    ...mapActions("account", ["logout"]),
    ...mapActions("labels", ["getLabel", "switchLocale"]),
    loadNotifications(index, number) {
      if (this.user && this.user.token && this.user.active) {
        AlertLogsService.loadAlertLogsWPaging(this.user._id, index, number)
          .then(logsPaging => {
            this.alertLogs = logsPaging.alertLogs.map(logs => { return { ...logs, date: moment(logs.date).format("DD-MM-YYYY HH:mm") } })
            this.lastPage = logsPaging.lastPage
          })
      }
    },
    loadNextNotifications() {
      this.pageNumber++;
      AlertLogsService.loadAlertLogsWPaging(this.user._id, this.pageNumber, this.notificationsPerPage)
        .then(logsPaging => {
          this.alertLogs = [ ...this.alertLogs, ...logsPaging.alertLogs ]
          this.lastPage = logsPaging.lastPage
        })
    },
    goTo(to) {
      this.menuExpanded = false;
      this.$router.push(to, () => {});
    },
    markAsSeen(id) {
      AlertLogsService.modifyAlertLogSeen(this.user._id, id, true)
        .then(() => {
          this.alertLogs.find(alertLog => alertLog.id === id).seen = true;
        })
    }
  },
  created() {
    this.getLabel({ view: 'header' })
    this.loadNotifications(this.pageNumber, this.notificationsPerPage)
    setInterval(this.loadNotifications(this.pageNumber, this.notificationsPerPage), 60000);
  }
};
</script>

<style lang="scss" scoped>
$yellow: #FFD204;
// arewal secondary color
$arewal-secondary-color: #767171;
.navbar-start .navbar-item {
  &.router-link-exact-active {
    border-bottom: 3px solid $arewal-secondary-color;
    font-weight: 700;
  }
}

.navbar-item {
  font-size: 1.1rem;

  img {
    max-height: 3.5rem;
  }
}

@media screen and (max-width: 1080px) {
  .dropdown {
    margin-left: 12px;
  }
  .navbar-item.navbar-flex {
    width: 100%;
    flex-wrap: wrap;
  }
}

.bell-icon {
  margin-bottom: 0.4rem;
  margin-right: 0.7rem;
  color: #000000b3;
  position: relative;

  &.hasNotif {
    margin-right: 1rem;
  }
}
.bell-notif {
  position: absolute;
  bottom: -.2rem;
  right: -.5rem;
  border-radius: 100%;
  background: #ff093b;
  color: white;
  width: 1rem;
  height: 1rem;
  font-size: .7rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  justify-content: flex-start;
}
@media screen and (min-width: 769px) {
  .modal-content {
    width: 500px;
  }
}
.modal-content {
  height: 500px;
  margin: 5rem 1rem 0 auto;
}
.modal-background {
  background-color: #0a0a0a25;
}
.horizontal-wrapper {
  display: flex;
  justify-content: space-between;
}

.notif {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: .5rem;

  &:not(:last-child) {
    padding-bottom: 1rem;
    border-bottom: 1px solid #0a0a0a25;
  }

  &-seen {
    margin-left: 1rem;

    &-button {
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background: #8796c9;

      &:hover {
        cursor: pointer;
      }
    }
  }
}

.see-more {
  margin-top: 1rem;
  display: flex;
  justify-content: center;

  & > .button {
    margin: 0
  }
}
</style>
